import React from 'react';

interface QuestionInputProps {
  question: string;
  onChange: (value: string) => void;
}

const QuestionInput: React.FC<QuestionInputProps> = ({ question, onChange }) => {
  return (
    <div>
      <label htmlFor="question-input" className="mb-2 block text-sm font-semibold text-gray-700">
        Question
      </label>
      <input
        id="question-input"
        type="text"
        value={question}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your question here..."
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
      />
    </div>
  );
};

export default QuestionInput;
